import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details, CampaignTabBar } from './components';
import useCampaign from './useCampaign';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const CampaignDetails = props => {
  const campaign = useCampaign('/campaign/recipients');
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CampaignTabBar onTabChange={campaign.onTabChange} />
      <div className={classes.content}>
        <Details campaign={campaign} showNav={true} />
      </div>
    </div>
  );
};

export default CampaignDetails;
